import type { OrderLineItem } from "../types";

// returnRequests is kept for API compatibility but not used here:
// `quantity_bought` from the order API already reflects Shopify's returnable quantity
// (which accounts for previous returns). Subtracting Baback return quantities on top
// would double-count and incorrectly hide still-returnable items.
export function filterReturnableItems(
  lineItems: OrderLineItem[],
  _returnRequests: unknown[],
): OrderLineItem[] {
  return lineItems.filter((lineItem) => (lineItem.quantity_bought ?? 0) > 0);
}
